import React from 'react'
import SearchInputField from '@components/SearchInputField'

import LanguageSwitcherCountry, { CountryLanguageSwitcher } from './LanguageSwitcherCountry'

interface LanguageSwitcherProperties {
  config: CountryLanguageSwitcher
}
const LanguageSwitcher: React.FC<LanguageSwitcherProperties> = ({ config }: LanguageSwitcherProperties) => {
  const [searchFilter, setSearchFilter] = React.useState('')
  const searchInputReference = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    // Focus the search input field when the modal opens
    if (!config.hideSearch && searchInputReference.current) {
      const inputElement = searchInputReference.current.querySelector('input')
      if (inputElement) {
        inputElement.focus()
      }
    }
  }, [config.hideSearch])

  const displayedNodes = React.useMemo(() => {
    return config.items.filter((countryNode) => {
      const countryMatches = countryNode.title.toLowerCase().includes(searchFilter.toLowerCase())
      const anyLanguageMatches = countryNode.languages.some((languageNode) =>
        languageNode.title.toLowerCase().includes(searchFilter.toLowerCase()),
      )

      return countryMatches || anyLanguageMatches
    })
  }, [config.items, searchFilter])

  return (
    <nav
      className="language-switcher"
      aria-label={`${config.navigationCountryAndLanguageLabel || 'Country and Language Selector'}`}
    >
      <p className="language-switcher__heading-label">{config.countrySwitchLabel}</p>
      {!config.hideSearch && (
        <div className="language-switcher__search-container" ref={searchInputReference}>
          <SearchInputField placeholder={config.searchPlaceholder} value={searchFilter} onChange={setSearchFilter} />
        </div>
      )}
      <ul className="language-switcher__country-list">
        {displayedNodes.map((countryNode) => (
          <LanguageSwitcherCountry
            countryNode={countryNode}
            countryPageLabel={config.countryPageLabel}
            key={countryNode.title}
          />
        ))}
      </ul>
    </nav>
  )
}

export default LanguageSwitcher
